<script setup lang="ts">
const props = defineProps<{ value: number }>()
const data = shallowReactive({
  up: undefined as undefined | 'up',
  arr: [{ num: props.value, index: 0 }] as { num: number; index: number }[],
})
watch(
  () => props.value,
  (num) => {
    const prev = data.arr?.at(0)?.num
    if (prev === num) return
    data.up = helpers.isDef(prev) && prev > num ? 'up' : undefined
    nextTick(() => (data.arr = [{ index: (data.arr?.at(-1)?.index || 0) + 1, num }]))
  },
  { immediate: true }
)
</script>

<template>
  <span :class="[$style.cont, data.up]">
    <TransitionGroup appear :enter-active-class="$style.enter" :enter-to-class="$style.active" :leave-active-class="$style.leave">
      <span v-for="item in data.arr" :key="item.index">{{ item.num }}</span>
    </TransitionGroup>
  </span>
</template>

<style module>
.cont {
  composes: global(_relative);
  composes: global(_fs09);
  composes: global(_fw-xl);
  composes: global(_mr04);
  composes: global(_txt_ctr);
  --d: 1;
}
.cont:global(.up) {
  --d: -1;
}
.cont span {
  display: inline-block;
  transition:
    transform 150ms linear,
    opacity 150ms linear;
  min-width: 20px;
}
.enter {
  opacity: 0.01;
  transform: translate(0, calc(-120% * var(--d)));
}
.active {
  opacity: 1;
  transform: translate(0, 0);
}
.leave {
  composes: global(_absolute);
  top: 0;
  left: 0;
  right: 0;
  transform: translate(0, calc(120% * var(--d)));
  opacity: 0.01;
}
</style>
